export const isHtmlContent = (text: string): boolean => {
	return /<[a-z][\s\S]*>/i.test(text);
};
